<template>
  <b-modal
      id="changeExpectedDeliveryDate-modal"
      ref="changeExpectedDeliveryDate-modal"
      :title="$t('history.modal.header.ChangeExpectedDeliveryDate')"
      @ok="changeExpectedDeliveryDate"
  >
    <form ref="form">
      <b-form-group
          label-cols-sm="4"
          :label="$t('history.modal.body.NewExpectedDeliveryDate')"
          label-align-sm="left"
      >
        <b-input-group size="sm">
          <b-col sm="10" class="shipDatePicker">
            <Datepicker
                v-model="expectedDeliveryDate"
                input-class="form-control form-control-sm"
                name="shipDatePicker"
                :disabled-dates="disabledDates"
                :monday-first="true"
                :typeable="false"
            />
          </b-col>
        </b-input-group>
      </b-form-group>
    </form>

    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="cancel()">
        Cancel
      </b-button>
      <b-button @click="ok()" name="changeExpectedDeliveryDateModalButton" variant="primary">
        {{ $t('history.modal.button.Change') }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { ACTIONS, HISTORY_PREFIX } from '@/store/constants';
import Datepicker from 'vuejs-datepicker';
import {format, subDays} from "date-fns";

export default {
  components: {
    Datepicker
  },

  props: {
    shipment: {type: Object, required: true}
  },

  data() {
    return {
      expectedDeliveryDate: this.shipment.expectedDeliveryDate,
      disabledDates: {
        days: []
      },
    };
  },
  created() {
    const date = new Date(this.shipment.shipDate);
    date.setHours(0,0,0,0);
    this.disabledDates.to = date;
  },

  methods: {
    showChangeExpectedDeliveryDateModal() {
      const date = new Date(this.shipment.shipDate);
      date.setHours(0,0,0,0);
      this.disabledDates.to = date;
      this.$refs['changeExpectedDeliveryDate-modal'].show();
    },

    changeExpectedDeliveryDate() {
      let obj = {shipment: this.shipment, expectedDeliveryDate: format(this.expectedDeliveryDate, 'yyyy/MM/dd')};

      this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.UPDATE_EXPECTED_DELIVERY_DATE, obj);

      this.shipment.expectedDeliveryDate = format(this.expectedDeliveryDate, 'yyyy-MM-dd');
    }
  },
};
</script>

<style></style>
